export const regionFarmerDetails = {
  chartKey: 'region_farmer_detail',
  chartTitle: 'Region Vs Farmer count',
  chartTitleQuery:
    "BEGIN declare @current_id date=':current_id',@param1 date=':param1', @param2 varchar(10)=':param2', @param6 varchar(10)=':param6', @param7 varchar(10)=':param7', @param8 varchar(10)=':param8', @param9 varchar(10)=':param9', @param5 varchar(10)=':param5'; IF @param9 != '' Begin select 'Farmer count for village' 'title' End; IF @param9 = '' and @param8 !='' Begin select 'village vs Farmer' 'title' End; IF @param9='' and @param8='' and @param7 !='' Begin select 'Taluk vs Farmer''title' End; IF @param9='' and @param8='' and @param7 ='' and @param6 != '' Begin select 'City vs Farmer' 'title' End; IF @param9='' and @param8='' and @param7='' and @param6 = '' and @param5 !='' Begin select 'State vs Farmer' 'title' End; IF @param9='' and @param8='' and @param7='' and @param6 = '' and @param5 ='' Begin select 'Country vs Farmer' 'title' End; end",
  chartTitleLocale: {
    'pan-IN': 'ਖੇਤਰ ਬਨਾਮ ਕਿਸਾਨ ਗਿਣਤੀ',
    'mr-IN': 'प्रदेश विरुद्ध शेतकरी संख्या'
  },
  chartSubTitle: null,
  chartSubTitleLocale: null,
  chartType: 'discreteBarChart',
  chartDatas: [
    {
      label: 'Bhandara',
      value: '57526',
      drilldown_value: '1'
    },
    {
      label: 'Chandrapur',
      value: '41265',
      drilldown_value: '1'
    },
    {
      label: 'Gondia',
      value: '28431',
      drilldown_value: '1'
    },
    {
      label: 'Nagpur',
      value: '19192',
      drilldown_value: '1'
    },
    {
      label: 'Raigad',
      value: '14222',
      drilldown_value: '1'
    },
    {
      label: 'Gadchiroli',
      value: '11911',
      drilldown_value: '1'
    }
  ],
  recordsQuery: '',
  filters: null,
  filterFields: [
    {
      inputType: 'date',
      modelName: 'Start Date',
      placeHolder: 'Start Date',
      placeHolderLocale: null,
      isRequired: false,
      fieldnumber: null,
      dataModel: '',
      fieldInfo: {
        minvalue: '',
        maxvalue: ''
      },
      value: {
        value: ':last_fortnight',
        values: null,
        type: 'text',
        record: null
      },
      customClass: ''
    },
    {
      inputType: 'date',
      modelName: 'End Date',
      placeHolder: 'End Date',
      placeHolderLocale: null,
      isRequired: false,
      fieldnumber: null,
      dataModel: '',
      fieldInfo: {
        minvalue: '',
        maxvalue: ''
      },
      value: {
        value: ':today',
        values: null,
        type: 'text',
        record: null
      },
      customClass: ''
    },
    {
      inputType: 'dropdown',
      modelName: 'Organization',
      placeHolder: 'Organization',
      placeHolderLocale: null,
      isRequired: false,
      fieldnumber: null,
      dataModel: 'dashboard_organization',
      fieldInfo: {
        minvalue: '',
        maxvalue: ''
      },
      value: {
        value: '',
        values: null,
        type: 'sql',
        record:
          "do $$\ndeclare v_entityid int =':entityid';\nbegin \n\tdrop table if exists temp_super_entity;\ncreate temp table temp_super_entity as \n\tselect entity_parent_id  from mas_entity m where m.id in (with hierarchy as (select entity_parent_id from mas_entity where id::int =v_entityid union select entity_parent_id from mas_entity where id in (select entity_parent_id from mas_entity where id::int =v_entityid) union select entity_parent_id from mas_entity where id in (select entity_parent_id from mas_entity where id in (select entity_parent_id from mas_entity where id::int =v_entityid)) ) select e.id from mas_entity e join hierarchy h on e.id=h.entity_parent_id where e.entity_parent_id = e.id);\nend $$;\nselect * from temp_super_entity;"
      },
      customClass: ''
    }
  ]
};

export const volumeInfo = {
  chartKey: 'volume_information_district_per_day',
  chartTitle: 'Region Vs Procurement Volume In A Day',
  chartTitleQuery: '',
  chartTitleLocale: null,
  chartSubTitle: null,
  chartSubTitleLocale: null,
  chartType: 'discreteBarChart',
  chartDatas: [
    {
      label: 'Bhandara',
      value: '54206',
      drilldown_value: '54206',
      tooltip: '54206.40 '
    },
    {
      label: 'Gondia',
      value: '32600',
      drilldown_value: '32600',
      tooltip: '32599.56 '
    },
    {
      label: 'Chandrapur',
      value: '8194',
      drilldown_value: '8194',
      tooltip: '8193.63 '
    },
    {
      label: 'Gadchiroli',
      value: '5203',
      drilldown_value: '5203',
      tooltip: '5203.40 '
    },
    {
      label: 'Nagpur',
      value: '501',
      drilldown_value: '501',
      tooltip: '500.52 '
    }
  ],
  recordsQuery: null,
  filters: null,
  filterFields: [
    {
      inputType: 'date',
      modelName: 'start_date',
      placeHolder: 'Start Date',
      placeHolderLocale: null,
      isRequired: false,
      fieldnumber: null,
      dataModel: '',
      fieldInfo: {
        minvalue: '',
        maxvalue: 'new Date()'
      },
      value: {
        value: ':today',
        values: null,
        type: 'text',
        record: null
      },
      customClass: ''
    },
    {
      inputType: 'date',
      modelName: 'end_date',
      placeHolder: 'End Date',
      placeHolderLocale: null,
      isRequired: false,
      fieldnumber: null,
      dataModel: '',
      fieldInfo: {
        minvalue: "new Date(':filter0')",
        maxvalue: 'new Date()'
      },
      value: {
        value: ':today',
        values: null,
        type: 'text',
        record: null
      },
      customClass: ''
    }
  ]
};

export const TopSocieties = {
  chartKey: 'region_farmer_detail',
  chartTitle: 'Top 5 Societies vs Procured Quantity (MT)',
  chartTitleQuery: '',
  chartTitleLocale: null,
  chartSubTitle: null,
  chartSubTitleLocale: null,
  chartType: 'discreteBarChart',
  chartDatas: [
    {
      label: 'ARMORI SAHAKARI SHETAKI KHAREDI VIKRI ARMORI REG.NO.630',
      value: '',
      drilldown_value: '0',
      tooltip: 'MT'
    },
    {
      label: 'Pragati Khanij Audhyogik Utpadak Sahkari Sanshtha Marya Amgaon',
      value: '',
      drilldown_value: '0',
      tooltip: 'MT'
    },
    {
      label: 'Goregaon Taluka Shetki K. V. Samiti Marya Goregaon',
      value: '',
      drilldown_value: '0',
      tooltip: 'MT'
    },
    {
      label:
        'CHAMORSHI TALUKA SAHKARI KHAREDI -VIKRI SANGHA CHAMORSHI REG.NO -626',
      value: '',
      drilldown_value: '0',
      tooltip: 'MT'
    },
    {
      label: 'Nandura Agro Farmer Producer  Co. Ltd. Nandura',
      value: '4146.65',
      drilldown_value: '0',
      tooltip: '              4,146.65MT'
    }
  ],
  recordsQuery: null,
  filters: null,
  filterFields: [
    {
      inputType: 'date',
      modelName: 'Start Date',
      placeHolder: 'Start Date',
      placeHolderLocale: null,
      isRequired: true,
      fieldnumber: null,
      dataModel: '',
      fieldInfo: {
        minvalue: '',
        maxvalue: ''
      },
      value: {
        value: ':last_fortnight',
        values: null,
        type: 'text',
        record: null
      },
      customClass: ''
    },
    {
      inputType: 'date',
      modelName: 'End Date',
      placeHolder: 'End Date',
      placeHolderLocale: null,
      isRequired: true,
      fieldnumber: null,
      dataModel: '',
      fieldInfo: {
        minvalue: '',
        maxvalue: ''
      },
      value: {
        value: ':today',
        values: null,
        type: 'text',
        record: null
      },
      customClass: ''
    },
    {
      inputType: 'dropdown',
      modelName: 'Organization',
      placeHolder: 'Organization',
      placeHolderLocale: null,
      isRequired: true,
      fieldnumber: null,
      dataModel: 'dashboard_organization',
      fieldInfo: {
        minvalue: '',
        maxvalue: ''
      },
      value: {
        value: '',
        values: null,
        type: 'sql',
        record:
          "do $$\ndeclare v_entityid int =':entityid';\nbegin \n\tdrop table if exists temp_super_entity;\ncreate temp table temp_super_entity as \n\tselect entity_parent_id  from mas_entity m where m.id in (with hierarchy as (select entity_parent_id from mas_entity where id::int =v_entityid union select entity_parent_id from mas_entity where id in (select entity_parent_id from mas_entity where id::int =v_entityid) union select entity_parent_id from mas_entity where id in (select entity_parent_id from mas_entity where id in (select entity_parent_id from mas_entity where id::int =v_entityid)) ) select e.id from mas_entity e join hierarchy h on e.id=h.entity_parent_id where e.entity_parent_id = e.id);\nend $$;\nselect * from temp_super_entity;"
      },
      customClass: ''
    }
  ]
};
export const TotalProcuredAmount = {
  chartKey: 'region_farmer_detail',
  chartTitle: 'Top 5 Societies vs Total Procured Amount',
  chartTitleQuery: '',
  chartTitleLocale: null,
  chartSubTitle: null,
  chartSubTitleLocale: null,
  chartType: 'discreteBarChart',
  chartDatas: [
    {
      label: 'ARMORI SAHAKARI SHETAKI KHAREDI VIKRI ARMORI REG.NO.630',
      value: '69644000',
      drilldown_value: '0',
      tooltip: '₹6,96,44,000.00'
    },
    {
      label:
        'CHAMORSHI TALUKA SAHKARI KHAREDI -VIKRI SANGHA CHAMORSHI REG.NO -626',
      value: '96342860',
      drilldown_value: '0',
      tooltip: '₹9,63,42,860.00'
    },
    {
      label: 'Goregaon Taluka Shetki K. V. Samiti Marya Goregaon',
      value: '83078093',
      drilldown_value: '0',
      tooltip: '₹8,30,78,093.00'
    },
    {
      label: 'Pragati Khanij Audhyogik Utpadak Sahkari Sanshtha Marya Amgaon',
      value: '74557536',
      drilldown_value: '0',
      tooltip: '₹7,45,57,536.00'
    },
    {
      label: 'CENTRAL KRUSHAK SEVA SAHKARI SANSTHA LTD. GONDIA REG.NO.112',
      value: '60614200',
      drilldown_value: '0',
      tooltip: '₹6,06,14,200.00'
    }
  ],
  recordsQuery: null,
  query:
    "do $$\r\ndeclare v_current_id DATE =TO_DATE(':current_id','dd/MM/yyyy');\r\ndeclare v_param1 DATE =TO_DATE(':param1','dd/MM/yyyy');\r\ndeclare v_param2 varchar = ':param2';\r\ndeclare v_param6 varchar = ':param6';\r\ndeclare v_param5 varchar = ':param5';\r\ndeclare v_param10 varchar = ':param10';\r\ndeclare v_logged_id varchar(256) = ':applicationUserId';\r\ndeclare v_entity  int = ':entityid';\r\ndeclare temp_offset integer;\r\n\r\nbegin\r\n\tDROP TABLE IF EXISTS sys_tmp_table_chart2;\r\n    CREATE TEMP TABLE sys_tmp_table_chart2(label varchar(200),\r\n    value int,\r\n    drilldown_value int,\r\n    tooltip varchar(200)\r\n    );\r\n   \r\n    SELECT 5 INTO temp_offset;\r\n    if (v_param2='' OR v_param2='0') then \r\n        v_entity=':entityid'::int;\r\n    else \r\n        v_entity=v_param2::int;\r\n    end if;   \r\n        \r\n\r\n         IF v_param6 = ''AND v_param5 ='' THEN\r\n\t\t raise notice 'district_name %',temp_offset;\r\n             insert into sys_tmp_table_chart2 \r\n            SELECT  me.entity_legal_name::varchar  as \"label\",\r\n            sum(pp.total_value)::int\"value\",0::int as \"drilldown_value\",\r\n\t\t\tREPLACE(concat(E'\\u20B9', TO_CHAR(sum(pp.total_value)::numeric,'99,99,99,99,99,999.99')), ' ', '')\"tooltip\"\r\n            FROM trn_agri_procurement p\r\n            JOIN trn_agri_procurement_products pp ON pp.procurement_id=p.id\r\n            join mas_entity me on me.id = p.entity_id\r\n            WHERE pp.total_value != 'NaN' and\r\n            cast(p.date_of_purchase as date) BETWEEN  v_current_id AND v_param1  \r\n            and (p.entity_id = v_entity OR p.entity_id IN (with hierarchy as (select id from mas_entity where id::int =v_entity\r\n\t\t\tunion select id from mas_entity where entity_parent_id::int =v_entity\r\n\t\t\tunion select id from mas_entity where entity_parent_id in (select id from mas_entity where entity_parent_id::int =v_entity)\r\n\t\t\tunion select id from mas_entity where entity_parent_id in \r\n\t\t\t(select id from mas_entity where entity_parent_id in (select id from mas_entity where entity_parent_id::int =v_entity))\r\n\t\t\t) select e.id from mas_entity e join hierarchy h on e.id=h.id)) and me.entity_classification = '2'\r\n            GROUP by me.entity_legal_name order by count(me.id) desc limit 5;\r\n        END IF;\r\n\r\nEND $$;\r\nselect * from sys_tmp_table_chart2;\r\n",
  filters: null,
  filterFields: [
    {
      inputType: 'date',
      modelName: 'Start Date',
      placeHolder: 'Start Date',
      placeHolderLocale: null,
      isRequired: true,
      fieldnumber: null,
      dataModel: '',
      fieldInfo: {
        minvalue: '',
        maxvalue: ''
      },
      value: {
        value: ':last_fortnight',
        values: null,
        type: 'text',
        record: null
      },
      customClass: ''
    },
    {
      inputType: 'date',
      modelName: 'End Date',
      placeHolder: 'End Date',
      placeHolderLocale: null,
      isRequired: true,
      fieldnumber: null,
      dataModel: '',
      fieldInfo: {
        minvalue: '',
        maxvalue: ''
      },
      value: {
        value: ':today',
        values: null,
        type: 'text',
        record: null
      },
      customClass: ''
    },
    {
      inputType: 'dropdown',
      modelName: 'Organization',
      placeHolder: 'Organization',
      placeHolderLocale: null,
      isRequired: true,
      fieldnumber: null,
      dataModel: 'dashboard_organization',
      fieldInfo: {
        minvalue: '',
        maxvalue: ''
      },
      value: {
        value: '',
        values: null,
        type: 'sql',
        record:
          "do $$\ndeclare v_entityid int =':entityid';\nbegin \n\tdrop table if exists temp_super_entity;\ncreate temp table temp_super_entity as \n\tselect entity_parent_id  from mas_entity m where m.id in (with hierarchy as (select entity_parent_id from mas_entity where id::int =v_entityid union select entity_parent_id from mas_entity where id in (select entity_parent_id from mas_entity where id::int =v_entityid) union select entity_parent_id from mas_entity where id in (select entity_parent_id from mas_entity where id in (select entity_parent_id from mas_entity where id::int =v_entityid)) ) select e.id from mas_entity e join hierarchy h on e.id=h.entity_parent_id where e.entity_parent_id = e.id);\nend $$;\nselect * from temp_super_entity;"
      },
      customClass: ''
    }
  ]
};
